import { useState, useRef, useCallback, useEffect } from "react";
import { Select, Form, Table, Spin, Input, Button, DatePicker, Checkbox } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import { useSelector, useDispatch } from "react-redux";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import csv from "../../assets/images/csv.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { useDownloadExcel } from "react-export-table-to-excel";
import { SearchOutlined, FilterFilled } from "@ant-design/icons";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import Loader from "react-spinners/BarLoader";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { getRegion } from "../../redux/actions/region.action";
import { getStyle } from "../../redux/actions/style";
import { getGender } from "../../redux/actions/gender.action";
import { getWashName } from "../../redux/actions/wash.action";
import { getSizeCurveReport } from "../../redux/actions/sizeCurveReport.action";
import { getInseam } from "../../redux/actions/inseam.action";
import { getCut } from "../../redux/actions/cut.action";
import { Chart } from "react-google-charts";
import { currencySymbol } from "../../utils/constants";

const { Option } = Select;
const SizeCurveReport = ({ token }) => {
  TabTitle("Size-Curve-Report");
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const company_id = ReadCookie("defaultCompany");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { saleOrderFormData, OmsReprot, sizeCurve, region, style, cut, gender, inseam } = useSelector(
    (state) => state
  );
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const tableRef = useRef(null);
  const [filters, setFilters] = useState([]);
  const [allStatus, setAllStatus] = useState(true);
  const [allFilters, setAllFilters] = useState([
    { id: 1, name: "Shipped", selected: false },
    { id: 2, name: "Return", selected: false },
    { id: 3, name: "POD", selected: false },
    { id: 4, name: "Pending", selected: false },
  ]);
  const [ptfilters, setPtFilters] = useState([]);
  const [ptAllStatus, setPtAllStatus] = useState(true);
  const [ptAllFilters, setPtAllFilters] = useState([
    { id: 2, name: "Majors", selected: false },
    { id: 14, name: "Dropship", selected: false },
    { id: 1, name: "Specialty", selected: false },
    { id: 3, name: "ECOM", selected: false },
    { id: 13, name: "INT", selected: false },
  ]);

  const statusSelectAll = (e) => {
    let copyArr = [...allFilters];
    copyArr.map((v) => {
      v.selected = false;;
      return v;
    });
    setAllFilters(copyArr);
    setAllStatus(e.target.checked);
  };

  useEffect(() => {
    if (allStatus) {
      setFilters([]);
    }
  }, [allStatus])

  const statusPTSelectAll = (e) => {
    let copyArr = [...ptAllFilters];
    copyArr.map((v) => {
      v.selected = false;;
      return v;
    });
    setPtAllFilters(copyArr);
    setPtAllStatus(e.target.checked);
  };

  useEffect(() => {
    if (ptAllStatus) {
      setPtFilters([]);
    }
  }, [ptAllStatus])

  const handlePrint = () => {
    window.print();
  };

  const handleChanges = (val) => {
    dispatch(getSaleOrderFormData(token, company_id, menuId, val, ""));
  };

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const optimizedFn = useCallback(debounce(handleChanges), []);

  const onFinish = async (e) => {
    setSubmit(true);
    setLoading(true);
    await form.validateFields().then((values) => {
      let status = []
      allFilters.filter((item) => {
        if (item.selected === true) {
          status.push(item.id)
        }
        return item;
      });
      let ptStatus = []
      ptAllFilters.filter((item) => {
        if (item.selected === true) {
          ptStatus.push(item.id)
        }
        return item;
      });
      dispatch(getSizeCurveReport(token, values, status, ptStatus)).then((res) => {
        setData(res?.payload?.data);
        setLoading(false);
        downloadExcelFileData(res?.payload?.data);
      });
    });
  };

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getStyle(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getInseam(token, menuId));
    dispatch(getCut(token, menuId))
  }, [dispatch, menuId, token]);

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          Division: v.gender_name,
          Region: v.region_name,
          Customer: v.customer_name,
          Year: v.years,
          Month: v.months,
          Status: v.status,
          "PO NO": v.reference_no,
          "Tran Type": v.tran_type,
          "Tran No": v.tran_no,
          "Start Date": moment(v.start_date).format("MM-DD-YYYY"),
          "Cancel Date": moment(v.cancel_date).format("MM-DD-YYYY"),
          SKU: v.sku,
          Inseam: v.inseam,
          Style: v.style_name,
          Wash: v.wash_name,
          "PT Status": v.pt_status_name,
          "Tracking Status": v.tracking_status,
          "CC Charge Status": v.cc_charge_status,
          "CIT Status": v.factor_decision,
          [`Amount ${currencySymbol}`]: v.shipped_amount,
          Unit: v.unit,
        };
      })
    );
  }

  const { onDownload: onDownloadReport } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Size Curve Report",
    sheet: "Sheet 1",
  });

  const groupedData = data && data?.reduce((acc, item) => {
    const key = item.style_name + item.first_size;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {}) || {};

  const shipStyleWiseData = Object.values(groupedData);

  shipStyleWiseData.forEach(group => {
    group.sort((a, b) => Number(b.totalqty || 0) - Number(a.totalqty || 0));
  });


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-2">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>
                <div className="col-sm-4 box-space right-content-header text-right pb-0">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class mr-8">
                      <div className="print_icon printing_class">
                        {OmsReprot?.payload?.data.length ? (
                          <i
                            id="Image1"
                            title="Print"
                            alt="Print"
                            src={btnPrint}
                            className="fa-solid fa-print printing_class"
                          ></i>
                        ) : (
                          <i
                            id="Image1"
                            title="Print"
                            alt="Print"
                            src={btnPrint}
                            className="fa-solid fa-print printing_class"
                            onClick={handlePrint}
                          ></i>
                        )}
                      </div>
                      <div className="print_icon printing_class">
                        <input
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={xlsx}
                          onClick={onDownloadReport}
                          style={{
                            borderWidth: "0px",
                            height: "14px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Size Curve Report
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="row printing_class">
                <div className="col text-sm-right pb-1"></div>
              </div>
              <>
                <div className="business_class_oms mb-2 distributor">
                  <Form form={form} name="control-hooks" onFinish={onFinish}>
                    <div className="main_form row">
                      <hr className="my-1" />
                      <div className="row">
                        <div className="checkboxes">
                          <label htmlFor="" style={{ marginRight: "35px" }}>Status:</label>
                          <div className="checkbox_content">
                            <Form.Item name="current_status_id" className=" mb-0">
                              <Checkbox
                                checked={allStatus} onChange={statusSelectAll}
                              >
                                All
                              </Checkbox>
                            </Form.Item>
                          </div>
                          {allFilters &&
                            allFilters.map((it, index) => {
                              return (
                                <div key={index} className="checkbox_content">
                                  <Form.Item name="current_status_id">
                                    <Checkbox
                                      checked={it.selected}


                                      onChange={(e) => {
                                        let copyArr = [...allFilters];
                                        if (e.target.checked) {
                                          copyArr[index].selected = true;
                                        } else {
                                          copyArr[index].selected = false;
                                        }
                                        setAllFilters(copyArr);
                                        setAllStatus(false);
                                      }}
                                    >
                                      {it.name}
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <div className="row">
                        <div className="checkboxes">
                          <label htmlFor="" style={{ marginRight: "15px" }}>Customer Type:</label>
                          <div className="checkbox_content">
                            <Form.Item name="pt_current_status_id" className=" mb-0">
                              <Checkbox
                                checked={ptAllStatus} onChange={statusPTSelectAll}
                              >
                                All
                              </Checkbox>
                            </Form.Item>
                          </div>
                          {ptAllFilters &&
                            ptAllFilters.map((it, index) => {
                              return (
                                <div key={index} className="checkbox_content">
                                  <Form.Item name="pt_current_status_id">
                                    <Checkbox
                                      checked={it.selected}
                                      onChange={(e) => {
                                        let copyArr = [...ptAllFilters];
                                        if (e.target.checked) {
                                          copyArr[index].selected = true;
                                        } else {
                                          copyArr[index].selected = false;
                                        }
                                        setPtAllFilters(copyArr);
                                        setPtAllStatus(false);
                                      }}
                                    >
                                      {it.name}
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <hr className="my-1" />
                      <div className="main_form row">
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width44">
                              From:
                            </label>
                            <div className="w-100">
                              <Form.Item
                                className="full_date"
                                name="from_date"
                                initialValue={moment().startOf("year")}
                              >
                                <DatePicker
                                  size="small"
                                  defaultValue={moment().format("MM-DD-YYYY")}
                                  className={"input-width"}
                                  format={"MM-DD-YYYY"}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width44">To:</label>
                            <div className="w-100">
                              <Form.Item
                                className="full_date"
                                name="to_date"
                                initialValue={moment().endOf("year")}
                              >
                                <DatePicker
                                  size="small"
                                  defaultValue={moment().format("MM-DD-YYYY")}
                                  className={"input-width"}
                                  format={"MM-DD-YYYY"}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width44">Sku</label>
                            <div className="w-100">
                              <Form.Item name="sku" className="sku_input">
                                <Input size="small" className={"select_Inputs mb-0"} />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label htmlFor="" className="labels width44">
                              Customer:
                            </label>
                            <div className="w-100 fit-selectbox-width">
                              <Form.Item name="customer" initialValue={"All"}>
                                <Select
                                  notFoundContent={
                                    saleOrderFormData.loading ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Loader
                                          type="Oval"
                                          color="#3c4b58"
                                          height={20}
                                          width={20}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          textAlign: "center",
                                        }}
                                      >
                                        No Data
                                      </div>
                                    )
                                  }
                                  className={"select_Inputs"}
                                  autoComplete={"nope"}
                                  size="small"
                                  showSearch
                                  optionFilterProp="children"
                                  loading={saleOrderFormData.loading}
                                  defaultValue={form.getFieldValue().customer}
                                  placeholder="Select Customer"
                                  onSearch={(value) => {
                                    optimizedFn(value);
                                  }}
                                >
                                  <Option value="All">All</Option>
                                  {saleOrderFormData?.payload?.customerDetail.map(
                                    (item) => {
                                      return (
                                        <Option
                                          defaultValue={"All"}
                                          key={item.customer_id}
                                          value={item.customer_id}
                                        >
                                          {" "}
                                          {`${item.customer_name}`}
                                        </Option>
                                      );
                                    }
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="main_form row form-margin">
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width44">Region:</label>
                            <div className="w-100 fit-selectbox-width">
                              <Form.Item name="region" initialValue={"All"}>
                                <Select
                                  className={"select_Inputs"}
                                  showSearch
                                  optionFilterProp="children"
                                  size="small"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  filterSort={(optionA, optionB) =>
                                    optionB?.value !== null ?
                                      optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                  }
                                >
                                  <Option value={null}>All</Option>
                                  {
                                    region?.payload?.data.map((val) => {
                                      return (
                                        <Option key={val.region_id} value={val.region_id}>{val.region_name}</Option>
                                      )
                                    })
                                  }
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width44">Style</label>
                            <div className="w-100 fit-selectbox-width">
                              <Form.Item initialValue={"All"} name="style">
                                <Select
                                  className={"select_Inputs"}
                                  showSearch

                                  optionFilterProp="children"
                                  size="small"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  filterSort={(optionA, optionB) =>
                                    optionB?.value !== null ?
                                      optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                  }
                                >
                                  <Option value={null}>All</Option>
                                  {style &&
                                    style?.payload?.data.map((style, index) => {
                                      return (
                                        <Option key={index} value={style.style_id}>
                                          {style.style_name}
                                        </Option>
                                      );
                                    })}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width44">Cut</label>
                            <div className="w-100 fit-selectbox-width">
                              <Form.Item initialValue={"All"} name="cut">
                                <Select
                                  className={"select_Inputs"}
                                  showSearch

                                  optionFilterProp="children"
                                  size="small"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  filterSort={(optionA, optionB) =>
                                    optionB?.value !== null ?
                                      optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                  }
                                >
                                  <Option value={null}>All</Option>
                                  {cut &&
                                    cut?.payload?.data?.map((status, index) => {
                                      return (
                                        <Option key={index} value={status.cut_id}>
                                          {status.cut_name}
                                        </Option>
                                      );
                                    })}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width44">Gender</label>
                            <div className="w-100">
                              <Form.Item initialValue={"All"} name="gender">
                                <Select
                                  className={"select_Inputs"}
                                  showSearch

                                  optionFilterProp="children"
                                  size="small"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  <Option value={null}>All</Option>
                                  {gender &&
                                    gender?.payload?.data.map((it, index) => {
                                      return (
                                        <Option key={index} value={it.gender_id}>
                                          {it.gender_name}
                                        </Option>
                                      );
                                    })}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>

                        </div>
                        <div className="main_form row form-margin" style={{ paddingRight: "0" }}>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label className="labels width44">Inseam</label>
                              <div className="w-100">
                                <Form.Item
                                  name="inseam"
                                  initialValue={"All"}
                                >
                                  <Select
                                    className={"select_Inputs"}
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {inseam?.payload?.data?.map((single) => {
                                      return (
                                        <Option
                                          value={`${single.inseam_name}`}
                                          key={single.inseam_id}
                                          label={single.inseam_name}
                                        >
                                          {single.inseam_name}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>

                          </div>
                          <div className="col-9" style={{ display: "flex", justifyContent: "flex-end", paddingRight: "0" }} >
                            <div
                              className=" d-flex flex-row align-items-baseline"
                              style={{
                                justifyContent: "start",
                                marginTop: "3px",
                              }}
                            >
                              <Button
                                type="primary"
                                htmlType="submit"
                                className="submit-btn-btm m-0"
                              >
                                Generate
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </>
            </div>
            <div>
              <div className="business_class_oms" ref={tableRef} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {loading ? (
                  <div className="loader" style={{ marginTop: "20px", textAlign: "center" }}>
                    <Spin size="large" />
                  </div>
                ) : (
                  shipStyleWiseData.length > 0 ? (
                    shipStyleWiseData.map((data, index) => {
                      const sizes = data;

                      let qty1 = null;
                      let qty2 = null;
                      let qty3 = null;
                      let qty4 = null;
                      let qty5 = null;
                      let qty6 = null;
                      let qty7 = null;
                      let qty8 = null;
                      let qty9 = null;
                      let qty10 = null;
                      let qty11 = null;
                      let qty12 = null;
                      let qty13 = null;
                      let qty14 = null;
                      let qty15 = null;
                      let qty16 = null;

                      for (let i = 0; i < data.length; i++) {
                        qty1 += parseInt(data[i].qty_1);
                        qty2 += parseInt(data[i].qty_2);
                        qty3 += parseInt(data[i].qty_3);
                        qty4 += parseInt(data[i].qty_4);
                        qty5 += parseInt(data[i].qty_5);
                        qty6 += parseInt(data[i].qty_6);
                        qty7 += parseInt(data[i].qty_7);
                        qty8 += parseInt(data[i].qty_8);
                        qty9 += parseInt(data[i].qty_9);
                        qty10 += parseInt(data[i].qty_10);
                        qty11 += parseInt(data[i].qty_11);
                        qty12 += parseInt(data[i].qty_12);
                        qty13 += parseInt(data[i].qty_13);
                        qty14 += parseInt(data[i].qty_14);
                        qty15 += parseInt(data[i].qty_15);
                        qty16 += parseInt(data[i].qty_16);
                      }
                      console.log("data", data)
                      let sumQ = 0;

                      for (let i = 0; i < data.length; i++) {
                        sumQ += parseInt(data[i].totalqty);
                      }

                      const total_qtys = data.reduce((sum, row) => {
                        return sum + (parseFloat(row.totalqty) || 0);
                      }, 0);

                      const chartData = [
                        ["Size (Label)", "Percentage"],
                        [sizes[0]?.size_1, (qty1 / total_qtys) * 100],
                        [sizes[0]?.size_2, (qty2 / total_qtys) * 100],
                        [sizes[0]?.size_3, (qty3 / total_qtys) * 100],
                        [sizes[0]?.size_4, (qty4 / total_qtys) * 100],
                        [sizes[0]?.size_5, (qty5 / total_qtys) * 100],
                        [sizes[0]?.size_6, (qty6 / total_qtys) * 100],
                        [sizes[0]?.size_7, (qty7 / total_qtys) * 100],
                        [sizes[0]?.size_8, (qty8 / total_qtys) * 100],
                        [sizes[0]?.size_9, (qty9 / total_qtys) * 100],
                        [sizes[0]?.size_10, (qty10 / total_qtys) * 100],
                        [sizes[0]?.size_11, (qty11 / total_qtys) * 100],
                        [sizes[0]?.size_12, (qty12 / total_qtys) * 100],
                        [sizes[0]?.size_13, (qty13 / total_qtys) * 100],
                        [sizes[0]?.size_14, (qty14 / total_qtys) * 100],
                        [sizes[0]?.size_15, (qty15 / total_qtys) * 100],
                        [sizes[0]?.size_16, (qty16 / total_qtys) * 100],
                      ];

                      return (
                        <div key={index}>
                          <div className="table_data-Heading distributr ">
                            <h3>{data[0].style_name} - {"1st Size: " + data[0].first_size}</h3>
                          </div>
                          <>
                            <table style={{ width: "100%" }} className="table_distributor-data distributr ">
                              <tbody>
                                <tr style={{ lineHeight: "32px", backgroundColor: "#e0e6ed" }}>
                                  <td className="font-weig">#</td>
                                  <td className="font-weig">Style</td>
                                  <td className="font-weig">Wash</td>
                                  <td className="font-weig">SKU</td>
                                  <td className="font-weig">Inseam</td>
                                  <td className="font-weig">1st Size</td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_1}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_2}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_3}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_4}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_5}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_6}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_7}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_8}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_9}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_10}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_11}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_12}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_13}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_14}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_15}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_16}
                                  </td>
                                  <td className="font-weig" style={{ textAlign: "right", width: "60px", padding: "0px 2px" }} >Quantity</td>

                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_1}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_2}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_3}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_4}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_5}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_6}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_7}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_8}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_9}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_10}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_11}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_12}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_13}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_14}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_15}
                                  </td>
                                  <td style={{ width: "40px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                    {sizes[0].size_16}
                                  </td>
                                  <td className="font-weig" style={{ textAlign: "right", width: "45px", padding: "0px 2px" }} >Total</td>
                                </tr>
                                {data.map((values, index) => {
                                  return (
                                    <tr key={index}>
                                      <td style={{ width: "30px" }}>{index + 1}</td>
                                      <td style={{ width: "120px" }}>{values.style_name}</td>
                                      <td style={{ width: "150px" }}>{values.wash_name}</td>
                                      <td style={{ width: "50px" }}>{values.sku}</td>
                                      <td style={{ width: "50px" }}>{values.inseam}</td>
                                      <td style={{ width: "60px" }}>{values.first_size}</td>
                                      {values.qty_1 && (
                                        <td key={index} style={{ textAlign: "right", padding: "2px" }} >{values.qty_1}</td>
                                      )}
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_2}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_3}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_4}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_5}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_6}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_7}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_8}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_9}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_10}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_11}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_12}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_13}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_14}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_15}</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_16}</td>
                                      <td style={{ textAlign: "right", paddingRight: "2px", width: "30px" }}>{values.totalqty}</td>

                                      {values.qty_1 && (
                                        <td key={index} style={{ textAlign: "right", padding: "2px" }} >{values.qty_1_per}%</td>
                                      )}
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_2_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_3_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_4_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_5_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_6_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_7_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_8_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_9_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_10_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_11_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_12_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_13_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_14_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_15_per}%</td>
                                      <td style={{ textAlign: "right", padding: "2px" }}>{values.qty_16_per}%</td>
                                      <td style={{ textAlign: "right", paddingRight: "2px", width: "40px" }}>{values.totalqty_per}%</td>
                                    </tr>
                                  );
                                })}

                                <tr>
                                  {[...Array(5)].map((_, i) => (
                                    <td key={`empty-${i}`} className="font-weig"></td>
                                  ))}
                                  <td className="font-weig">Total</td>

                                  {(() => {
                                    const quantities = [
                                      qty1, qty2, qty3, qty4, qty5, qty6, qty7, qty8,
                                      qty9, qty10, qty11, qty12, qty13, qty14, qty15, qty16
                                    ];
                                    const validQuantities = quantities.map(q => isNaN(q) ? 0 : q);
                                    const sumQ = validQuantities.reduce((a, b) => a + b, 0);

                                    return (
                                      <>
                                        {validQuantities.map((qty, index) => (
                                          <td key={`qty-${index}`} className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                                            {qty !== qty ? "" : qty}
                                          </td>
                                        ))}
                                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                                          {numeral(sumQ).format("0,00,0")}
                                        </td>
                                        {validQuantities.map((qty, index) => (
                                          <td key={`perc-${index}`} className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                                            {sumQ === 0 ? "" : ((qty / sumQ) * 100).toFixed(0) + "%"}
                                          </td>
                                        ))}
                                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                                          {numeral((sumQ / sumQ) * 100).format("0") + "%"}
                                        </td>
                                      </>
                                    );
                                  })()}

                                </tr>
                              </tbody>
                            </table>
                            {chartData?.length > 0 ? <div id="ignore">
                              <Chart
                                chartType="BarChart"
                                width="100%"
                                height="500px"
                                data={chartData}
                                options={{
                                  title: style,
                                  titleTextStyle: {
                                    fontSize: 18, // 👈 smaller font size
                                    bold: true,
                                  },
                                  colors: ["#3c4b58"],
                                  chartArea: {
                                    width: "40%",
                                    height: "40%",
                                    top: 80,
                                    bottom: 80,
                                  },
                                  hAxis: {
                                    textStyle: {
                                      fontSize: 12
                                    }
                                  },
                                  vAxis: {
                                    textStyle: {
                                      fontSize: 12
                                    }
                                  },
                                  legend: {
                                    textStyle: {
                                      fontSize: 12
                                    }
                                  }
                                }}
                              />
                            </div> : 'no data'}
                          </>
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-Data" style={{ width: '65%' }}>
                      <h1>No Data</h1>
                    </div>
                  )
                )}
                { }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SizeCurveReport;
